module.exports = __webpack_public_path__ + "img/uni_selection_arrow.416a3622.svg";